import type { HelpFile } from '../../types/help'
import { ComboboxTestIds } from '../../../testids/ComboboxTestIds'

export const comboboxHelp: HelpFile = {
  texts: {
    [ComboboxTestIds.btnClearSelection]: null,
  },
}
